import { render, staticRenderFns } from "./ManualSetting.vue?vue&type=template&id=15859969&scoped=true"
import script from "./ManualSetting.vue?vue&type=script&lang=js"
export * from "./ManualSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15859969",
  null
  
)

export default component.exports